export const CATELOUEIMPORT_COUNT_SET = 'CATELOUEIMPORT_COUNT_SET';
export const CATELOUEIMPORT_COUNT_NOTIFI_SET = 'CATELOUEIMPORT_COUNT_NOTIFI_SET';